import { useState, useEffect, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import ImagePreview from "../../components/FormsUI/PreviewImage/index";
import DepartmentController from "../../controller/DepartmentController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
    Container,
    Grid,
    useTheme,
    Box,
    Stack,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";


const INITIAL_FORM_STATE = {
    departmentName: "",
    departmentCode: "",
    departmentImage: null,
};
const FORM_VALIDATION = Yup.object().shape({
    departmentName: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Department Name is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "Department Name should not exceed 100 characters")
        .required("Department Name is required"),
    departmentCode: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "department Code  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Department Code should not exceed 50 characters")
        .optional(),
    departmentImage: Yup.mixed().optional(),

});


let requestType = "";
const Department = () => {
    const fileInputRef = useRef(null);
    const departmentController = new DepartmentController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [department, setDepartment] = useState([])
    const [departmentImg, setDepartmentImg] = useState();
    const [popupPreview, setPopUpPreview] = useState({
        departmentImg: false
    });
    const previewPopUpImage = (field, value) =>
        setPopUpPreview((prev) => ({ ...prev, [field]: value }));
    const [loader, setLoader] = useState(true);
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [popup, setPopUp] = useState(false);
    const [allUsers, setAllUsers] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllDepartment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAllDepartment = async () => {
        let caughtError;
        try {
            const response = await departmentController.GetAllDepartment(token);
            if (response.status === 200) {
                const departmentData = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setDepartment(departmentData);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDepartment",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const saveFile = ({ e, setFieldValue, field }) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 4) {
            showAlert("error", "Document size should not be more than 4MB");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            return;
        }

        const extFile = getFileExtension(file.name);
        if (!isValidImageExtension(extFile)) return;

        const reader = new FileReader();
        const WIDTH = 1024;
        const IMAGE_H = 682;
        reader.onload = (event) => {
            const image = new Image();
            image.onload = () => {
                const width = image.naturalWidth;
                const height = image.naturalHeight;
                const aspectRatio = width / height;

                const REQUIRED_ASPECT_RATIO = 1024 / 682;
                const TOLERANCE = 0.3;

                if (Math.abs(aspectRatio - REQUIRED_ASPECT_RATIO) > TOLERANCE) {
                    showAlert(
                        "error",
                        `Invalid aspect ratio. Required: ${WIDTH}x${IMAGE_H} (${REQUIRED_ASPECT_RATIO.toFixed(2)})`
                    );
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    return;
                }
                // If all checks pass
                setDepartmentImg(event.target.result);
                setFieldValue(field, file);
            };

            image.onerror = () => {
                showAlert("error", "Invalid image file.");
            };

            image.src = event.target.result;
        };

        reader.readAsDataURL(file);
    };

    const getFileExtension = (filename) => {
        return filename.split(".").pop().toLowerCase();
    };
    const isValidImageExtension = (ext) => {
        const validExtensions = ["jpg", "jpeg", "png"];
        if (!validExtensions.includes(ext)) {
            showAlert("error", "Only jpeg, png and jpg images are allowed");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            return false;
        }
        return true;
    };


    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Department Name", field: "departmentName", width: 210 },
        { headerName: "Department Code", field: "departmentCode", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 210,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedValues(() => currentRowData);
                            setDepartmentImg(currentRow.departmentImg)
                            handleData();
                        } else {
                            departmentController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllDepartment()
                                        showAlert("success", "Deleted successfully");
                                        setAllUsers((i) => {
                                            return allUsers.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "Department onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const AddDepartment = async () => {
        // getRolesDD();
        requestType = "Add";
        setUpdatedValues(() => INITIAL_FORM_STATE);
        setDepartmentImg(null)
        handleData();
    };


    const submitValues = (submitValueData) => {
        let submitData = new FormData();
        // tenantId coming from parent/component
        submitData.append("tenantId", tenantId);
        // Map form fields
        submitData.append("departmentName", submitValueData?.departmentName?.trim() ?? "");
        submitData.append("departmentCode", submitValueData?.departmentCode?.trim() ?? "");
        submitData.append("departmentImage", submitValueData?.departmentImg ?? "");

        //add for image
        if (requestType === "Edit") {
            // debugger
            submitData.append("id", submitValueData?.id);
            const departmentId = submitValueData?.id;
            // assuming ID comes from backend
            departmentController
                .Update(departmentId, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllDepartment()
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.data?.status === 204)
                            showAlert("error", response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            departmentController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllDepartment()
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 409) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);
    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <h6 className="breadsub">Medical</h6>
                                        </li>
                                        <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>Department</h6>
                                        </li>
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="adduser">
                        <Controls.ActionButton onClick={() => AddDepartment()}>
                            <span>Add New</span>
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item xs={12} className="formBg">
                        <Container maxWidth="md" className="formClwidth">
                            <div>
                                <Controls.Grid
                                    columns={columns}
                                    data={department}
                                    fileName={"Users"}
                                />
                                {popup && (
                                    <Controls.Popup
                                        title="Department Details"
                                        openPopup={popup}
                                        setOpenPopup={handlePopup}
                                    >
                                        <Formik
                                            enableReinitialize
                                            initialValues={{
                                                ...(updatedValues || INITIAL_FORM_STATE),
                                            }}
                                            validationSchema={FORM_VALIDATION}
                                            onSubmit={(values) => submitValues(values)}
                                        >
                                            {({ values, setFieldValue }) => (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="departmentName"
                                                                label="Department Name"
                                                                type="string"
                                                                inputProps={{ maxLength: 100 }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="departmentCode"
                                                                label="Department Code"
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <h3 className="upload">
                                                                Department Image <span className="asterisk">*</span>
                                                            </h3>
                                                            <input
                                                                type="file"
                                                                name="departmentImg"
                                                                ref={fileInputRef}
                                                                onChange={(e) => {
                                                                    let field = "departmentImg";
                                                                    saveFile({ e, setFieldValue, field });
                                                                }}
                                                                className="fileupload"
                                                                style={{ width: "70%" }}
                                                            />
                                                            <Grid className="col-lg-2" style={{ float: "right", marginRight: "1px" }}>
                                                                {departmentImg && (
                                                                    <img
                                                                        src={departmentImg}
                                                                        width="55"
                                                                        style={{ cursor: "pointer" }}
                                                                        height="55"
                                                                        onClick={() =>
                                                                            setPopUpPreview((prev) => ({
                                                                                ...prev,
                                                                                departmentImg: true,
                                                                            }))
                                                                        }
                                                                        alt="Logo"
                                                                        className="imgview"
                                                                    />
                                                                )}
                                                                <ImagePreview
                                                                    image={departmentImg}
                                                                    popup={popupPreview?.departmentImg}
                                                                    field={"departmentImg"}
                                                                    handlePopup={previewPopUpImage}
                                                                />
                                                            </Grid>

                                                            <ErrorMessage name="departmentImg">
                                                                {(msg) => (
                                                                    <div style={{ color: "#d32f2f" }}>{msg}</div>
                                                                )}
                                                            </ErrorMessage>
                                                        </Grid>
                                                        <br />
                                                    </Grid>
                                                    <Grid item xs={4} md={2} className="marginAuto">
                                                        <Controls.Button>Submit</Controls.Button>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Controls.Popup>
                                )}
                            </div>
                        </Container>
                    </Grid>
                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box>
        </>
    );
};

export default Department;
